import { render } from "./NotificationSetting.vue?vue&type=template&id=28e7a2de&scoped=true"
import script from "./NotificationSetting.vue?vue&type=script&lang=js"
export * from "./NotificationSetting.vue?vue&type=script&lang=js"

import "./NotificationSetting.vue?vue&type=style&index=0&id=28e7a2de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e7a2de"]])

export default __exports__